import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bf_token');
  if (token) config.headers.Authorization = 'Bearer ' + token;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('bf_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register:       (d) => api.post('/auth/register', d),
  login:          (d) => api.post('/auth/login', d),
  me:             ()  => api.get('/auth/me'),
  forgotPassword: (d) => api.post('/auth/forgot-password', d),
  resetPassword:  (d) => api.post('/auth/reset-password', d),
  verifyEmail:    (t) => api.get('/auth/verify-email/' + t),
};
export const incomeAPI = {
  list:   (p)    => api.get('/income', { params: p }),
  create: (d)    => api.post('/income', d),
  update: (id,d) => api.put('/income/' + id, d),
  remove: (id)   => api.delete('/income/' + id),
};
export const expensesAPI = {
  list:   (p)    => api.get('/expenses', { params: p }),
  create: (d)    => api.post('/expenses', d),
  update: (id,d) => api.put('/expenses/' + id, d),
  remove: (id)   => api.delete('/expenses/' + id),
};
export const categoriesAPI = {
  list:   ()     => api.get('/categories'),
  create: (d)    => api.post('/categories', d),
  update: (id,d) => api.put('/categories/' + id, d),
  remove: (id)   => api.delete('/categories/' + id),
};
export const budgetsAPI = {
  list:   (p)  => api.get('/budgets', { params: p }),
  create: (d)  => api.post('/budgets', d),
  upsert: (d)  => api.post('/budgets', d),
  remove: (id) => api.delete('/budgets/' + id),
};
export const statsAPI = {
  dashboard: (p) => api.get('/stats/dashboard', { params: p }),
  trend:     ()  => api.get('/stats/trend'),
};
export const usersAPI = {
  updateProfile:  (d) => api.put('/users/profile', d),
  changePassword: (d) => api.put('/users/password', d),
  deleteAccount:  ()  => api.delete('/users/account'),
};
export const subscriptionsAPI = {
  createOrder:  (d) => api.post('/subscriptions/create-order', d),
  captureOrder: (d) => api.post('/subscriptions/capture-order', d),
  status:       ()  => api.get('/subscriptions/status'),
};
export const familyAPI = {
  getGroup:       ()        => api.get('/family/group'),
  createGroup:    (d)       => api.post('/family/group', d),
  updateGroup:    (d)       => api.put('/family/group', d),
  deleteGroup:    ()        => api.delete('/family/group'),
  getMembers:     ()        => api.get('/family/members'),
  addMember:      (d)       => api.post('/family/members', d),
  updateMember:   (id, d)   => api.patch('/family/members/' + id, d),
  removeMember:   (id)      => api.delete('/family/members/' + id),
  getExpenses:    (p)       => api.get('/family/expenses', { params: p }),
  addExpense:     (d)       => api.post('/family/expenses', d),
  updateExpense:  (id, d)   => api.put('/family/expenses/' + id, d),
  deleteExpense:  (id)      => api.delete('/family/expenses/' + id),
  getIncome:      (p)       => api.get('/family/income', { params: p }),
  getBudgets:     (p)       => api.get('/family/budgets', { params: p }),
  saveBudget:     (d)       => api.post('/family/budgets', d),
  getStats:       (p)       => api.get('/family/stats', { params: p }),
  getInvite:      (token)   => api.get('/family/join/' + token),
  acceptInvite:   (token)   => api.post('/family/join/' + token),
};
export const adminAPI = {
  stats:      ()     => api.get('/admin/stats'),
  users:      (p)    => api.get('/admin/users', { params: p }),
  updateUser: (id,d) => api.patch('/admin/users/' + id, d),
};
export const notificationsAPI = {
  get: (p) => api.get('/notifications', { params: p }),
};
export default api;